export const gender = {
    male: { value: "MALE", label: "Male" },
    female: { value: "FEMALE", label: "Female" },
    other: { value: "TRANSGENDER", label: "Transgender" },
}

export const genderDropdown = [
    {value: gender.male.value, name: gender.male.value},
    {value: gender.female.value, name: gender.female.value},
    {value: gender.other.value, name: gender.other.value},
]